<input style="width: 0; padding: 0; border: 0; height: 100%" placeholder="yyyy-mm-dd" (dateSelect)="onDateSelection($event)" (closed)="selectIfNeeded()"
       [autoClose]="autoClose" [startDate]="fromNgbDate" [displayMonths]="2" [dayTemplate]="dayTemplate" outsideDays="hidden" [footerTemplate]="footerTemplate"
       name="dp" [(ngModel)]="date" ngbDatepicker #d="ngbDatepicker" container="body" [placement]="'bottom-start bottom-end end start top'" [datepickerClass]="class">
<ng-template #dayTemplate let-date let-focused="focused">
    <span class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.isFrom]="isFrom(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = null">
      {{ date.day }}
    </span>
</ng-template>

<ng-template #footerTemplate>
  <ng-container *transloco="let t; read: 'mes.ngbd-datepicker-range'">
    <div class="d-flex justify-content-around" *ngIf="showTimePicker">
      <ngb-timepicker name="fromTimepicker" [ngModel]="fromTime" [seconds]="showSeconds" (ngModelChange)="fromDate = onTimeChange($event, fromDate)"></ngb-timepicker>
      <ngb-timepicker name="toTimepicker" [ngModel]="toTime" [seconds]="showSeconds" (ngModelChange)="toDate = onTimeChange($event, toDate)"></ngb-timepicker>
    </div>
    <div class="d-flex" *ngIf="showTime">
      <button class="btn flex-fill btn-outline-secondary m-1" type="button" (click)="toggleDateTimeState($event)">
        {{(fromDate | date: showSeconds ? 'HH:mm:ss' : 'HH:mm') || '-'}}
      </button>
      <button class="btn flex-fill btn-outline-secondary m-1" type="button" (click)="toggleDateTimeState($event)">
        {{(toDate | date: showSeconds ? 'HH:mm:ss' : 'HH:mm') || '-'}}
      </button>
    </div>
    <hr class="my-0">
    <div class="d-flex m-1">
      <input class="form-control form-control-sm px-1 my-auto" placeholder="dd.mm.yyyy" style="width: 5.2rem"
             name="dpFromDate" #dpFromDate
             [value]="formatter.format(fromNgbDate)"
             (input)="validateFromInput(dpFromDate.value)">
      <span class="m-1"> - </span>
      <input class="form-control form-control-sm px-1 my-auto" placeholder="dd.mm.yyyy" style="width: 5.2rem"
             name="dpToDate" #dpToDate
             [value]="formatter.format(toNgbDate)"
             (input)="validateToInput(dpToDate.value)">
      <div class="btn-group ms-auto" role="group">
        <button class="btn btn-outline-primary btn-sm" (click)="selectPreviousPeriod(); d.close()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-left"></svg>
        </button>
        <div class="dropdown" ngbDropdown container="body">
          <button class="dropdown-toggle btn btn-outline-primary" ngbDropdownToggle role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{t('Vahemikud')}}
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <button class="dropdown-item" ngbDropdownItem (click)="selectToday()">{{t('Täna')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectYesterday()">{{t('Eile')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectThisWeek()">{{t('Käesolev nädal')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectLastWeek()">{{t('Eelmine nädal')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectThisMonth()">{{t('Käesolev kuu')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectLastMonth()">{{t('Eelmine kuu')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectFromLastMonth()">{{t('Eelmise kuu algusest')}}</button>
            <button class="dropdown-item" ngbDropdownItem (click)="selectFromStartOfYear()">{{t('Aasta algusest')}}</button>
          </div>
        </div>
        <button class="btn btn-outline-primary btn-sm" (click)="selectNextPeriod(); d.close()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#chevron-right"></svg>
        </button>
      </div>
      <button class="btn btn-secondary btn-sm ms-1" (click)="select(null, null); d.close()" title="Clear">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#x-mark"></svg>
      </button>
      <button class="btn btn-secondary btn-sm ms-1" (click)="d.close(); emitSelection()">{{t('OK')}}</button>
    </div>
  </ng-container>
</ng-template>

